<template>
  <SelectLayout>
    <section class="fopag">
      <div class="municipio-selector">
        <h1>Folha de Pagamento</h1>
        <label for="fopag">Selecione o Município:</label>
      </div>
      <div class="field">
        <SearchableSelect
          :value="selectedUrl"
          :options="clienteOptions"
          placeholder="Selecione"
          search-placeholder="Buscar Município..."
          @input="onSelect"
        />
      </div>
    </section>
  </SelectLayout>
</template>

<script>
import SelectLayout from '@/components/layout/SelectLayout.vue'
import SearchableSelect from '@/components/ui/SearchableSelect.vue'
import { listClientes } from '@/services/socialApi.js'

export default {
  name: "Fopag",
  components: { SelectLayout, SearchableSelect },
  data() {
    return {
      selectedUrl: '',
      fopagClientes: []
    }
  },
  computed: {
    clienteOptions() {
      return this.fopagClientes.map((cliente, i) => ({
        value: cliente.url || String(i),
        label: `${cliente.cidade}, ${cliente.uf}`
      }))
    }
  },
  methods: {
    onSelect(url) {
      this.selectedUrl = url
      if (!url) return

      let destino
      try {
        destino = new URL(url.includes('://') ? url : `https://${url}/`)
      } catch (e) {
        return
      }

      if (destino.protocol !== 'http:' && destino.protocol !== 'https:') return

      window.location.href = destino.href
    }
  },
  mounted() {
    listClientes('fopag').then(response => {
      this.fopagClientes = response.data
    }).catch(() => {
      // lista fica vazia em caso de falha na API
    })
  }
}
</script>

<style scoped>
.fopag {
  width: 100%;
  max-width: 32rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.fopag h1 {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.fopag label {
  font-size: 14px;
  text-align: center;
  color: #ccc;
  display: flex;
  justify-content: center;
}

.field {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 12px;
  color: #ccc;
}

@media only screen and (max-width: 480px) {
  .fopag {
    gap: 12px;
  }

  .fopag h1 {
    font-size: 20px;
  }

  .fopag label {
    font-size: 13px;
  }
}
</style>
